var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4496 4.28407C39.4496 2.14509 37.6996 0.39502 35.5606 0.39502H4.44814C2.30916 0.39502 0.559082 2.14509 0.559082 4.28407V27.6184C0.559082 29.7574 2.30916 31.5074 4.44814 31.5074H35.5606C37.6996 31.5074 39.4496 29.7574 39.4496 27.6184V4.28407ZM35.5606 4.28407L20.0044 14.0067L4.44814 4.28407H35.5606ZM35.5606 27.6184H4.44814V8.17312L20.0044 17.8957L35.5606 8.17312V27.6184Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.d0c4d9ff79744e74705baca77c8902cd.svg";
export { ForwardRef as ReactComponent };